import { render, staticRenderFns } from "./SkuStockDetail.vue?vue&type=template&id=204c9978&scoped=true&"
import script from "./SkuStockDetail.vue?vue&type=script&lang=js&"
export * from "./SkuStockDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204c9978",
  null
  
)

export default component.exports